/**
 * Routes served by the analytics SPA (effy-fe's `apps/analytics`), mounted under
 * the `/a` basename. These are not Next.js pages — crossing into them needs a
 * full page load. Keep in sync with `analyticsAppRoutes` in effy-fe.
 */
export const ANALYTICS_APP_BASENAME = '/a';

const routes = {
  AnalyticsAppOverview: () => ANALYTICS_APP_BASENAME,
  AnalyticsAppDashboards: () => `${ANALYTICS_APP_BASENAME}/dashboards`,
  AnalyticsAppReports: () => `${ANALYTICS_APP_BASENAME}/reports`,
  AnalyticsAppExports: () => `${ANALYTICS_APP_BASENAME}/deliveries`,
};

export default routes;
